module.exports = __webpack_public_path__ + "assets_1777427128813/img/pic_7.731956bc.png";